import { columnsTableObjReal,subTitlesTableObjReal } from './OBJREAL';
import {columnsTableTendVeh,subTitlesTableTendVeh} from './TENDVEH/';
import { columnsTableTenObj,subTitlesTableTenObj } from './TENOBJ/';
import { columnsTable as columnsTableProObjTend, subTitlesTable as subTitlesTableProObjTend } from './PROOBJTEND';
import { columnsTableRealObj, subTitlesTableRealObj } from './REALOBJ';

export const COLUMNSREPORT = (año, idVersion) => {
    return{
        TENDVEH: columnsTableTendVeh(idVersion),
        TENDOBJ: columnsTableTenObj(año, idVersion),
        PROPOBJVEH: columnsTableTendVeh,
        OBJREAL: columnsTableObjReal(año, idVersion),
        PROOBJTEND: columnsTableProObjTend(año, idVersion),
        REALOBJ: columnsTableRealObj(año, idVersion)
    }
}

export const SUBTITLESREPORT = (año, idVersion) => {
    return {
        TENDVEH: subTitlesTableTendVeh(idVersion),
        OBJREAL: subTitlesTableObjReal(año, idVersion),
        TENDOBJ: subTitlesTableTenObj(año, idVersion),
        PROOBJTEND: subTitlesTableProObjTend(año, idVersion),
        REALOBJ: subTitlesTableRealObj(año, idVersion)
    }
}